import { render, staticRenderFns } from "./BABSDetay.vue?vue&type=template&id=3e278b62&"
import script from "./BABSDetay.vue?vue&type=script&lang=js&"
export * from "./BABSDetay.vue?vue&type=script&lang=js&"
import style0 from "./BABSDetay.vue?vue&type=style&index=0&id=3e278b62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports